var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-20",attrs:{"id":"base-editor-page"}},[_c('div',{staticClass:"panel panel-default"},[_c('div',{staticClass:"panel-body"},[_c('OverviewContainer'),_vm._v(" "),_vm._l((_vm.authorProjects),function(project){return _c('VersionContainer',{key:project.versionKey,attrs:{"versionData":project}})})],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }